import { createContext } from 'react';

const FetchDataContext = createContext();

export default FetchDataContext;